import type { FC } from 'react';
import type { BeneficialOwnerResponse } from '@gcv/shared';
import { Box } from '@mui/material';

import { Button, Dialog, Text } from 'ui';

interface Props {
  isOpen: boolean;
  isArchiving: boolean;
  owner: BeneficialOwnerResponse;
  onArchive: () => void;
  onClose: () => void;
}

export const CrbArchiveBeneficialOwnerModal: FC<Props> = ({
  isOpen,
  isArchiving,
  owner,
  onArchive,
  onClose
}) => {
  const ownerName = [
    owner.beneficial_owner_first_name,
    owner.middle_initial,
    owner.beneficial_owner_last_name
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <Dialog
      dataCy="archive-beneficial-owner-modal"
      handleClose={onClose}
      isOpen={isOpen}
      noActions
      title="Archive this beneficial owner?"
    >
      <Text
        content={`Archiving removes ${ownerName} from your active ownership record. Your connected providers will be notified that this beneficial owner was archived, and they may follow up with questions.`}
        sx={{ marginBottom: 2 }}
        type="body1"
      />
      <Text content="You can view archived owners at any time." type="body1" />
      <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', marginTop: 4 }}>
        <Box sx={{ width: '80%' }}>
          <Button
            color="warning"
            fullWidth
            isLoading={isArchiving}
            label="Archive owner"
            onClick={onArchive}
          />
        </Box>
        <Button color="default-text" disabled={isArchiving} label="Cancel" onClick={onClose} />
      </Box>
    </Dialog>
  );
};
